import React from 'react'
// import FacebookIcon from '../Icons/FacebookIcon'
// import Instagram from '../Icons/Instagram'
// import LinkinIcon from '../Icons/LinkinIcon'
// import WhatsApp from '../Icons/WhatsApp'
import {Link} from 'react-router-dom';
import logo from '../images/logo2.png';
import {PhoneIcon,ArrowRightIcon,EnvelopeIcon,MapPinIcon} from '@heroicons/react/24/outline';
export const Footer2 = () => {
  return (
    <>
    <div className='font-work min-w-min   border-t border-gray-700  bg-[#554256] text-white pt-10 px-8'>
        <div className='container mx-auto'>
        <div className='flex  px-8  flex-col  md:flex-row   '>
        <div className=' w-full md:w-1/2 flex flex-col  justify-center  items-center' >
        <img src={logo} alt='lgo' className='flex w-3/5 justify-center items-center' />

        </div>
      
        <div className=' w-full pt-5 md:pt-0  md:w-1/4  flex flex-col justify-center items-center'> 
            <p className='text-primary  font-bold text-2xl  '>Quick Links</p>
            <div className='flex flex-col pt-2   text-white  text-lg'>
            <a  href="/#services" className='hover:underline'>
                Services
            </a>
            <a  href="/#products" className='hover:underline'> 
                Projects
            </a>
            <a  href="/#values" className='hover:underline'>
                Values
            </a>
            
            
            <a  href="/contact" className='hover:underline'>
                Contact Us
            </a>
            </div>
            
        </div>
      

        <div className='flex flex-col  pt-5 md:pt-0 ' >
     
        <h1 className='text-primary text-2xl  font-bold text-center md:items-start pb-5'>Find Us</h1>
      
        <p className='w-full flex justify-center text-center tetx-lg  md:text-left items-center md:justify-start md:items-start '>Lahore, Pakistan</p>
        <ul className="flex justify-center item-center pt-3 mb-4 md:mb-0">
                                    <li>
                                        <Link to="#" className="flex justify-center items-center text-[#558b97] hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Twitter">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                                        </svg>
                                        </Link>
                                    </li>
                                    <li className="ml-4">
                                        <Link to="#" className="flex justify-center items-center text-[#558b97] hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>
                                        </Link>
                                    </li>
                                </ul>
        </div>
     
       
        </div>
        
<div className='border-[1px] border-gray-500 mt-10 w-full' />
<div className='flex  md:justify-between md:flex-row flex-col justify-center items-center w-full py-3'>
<p className=' text-white text-center w-full pb-3'>© Copyright 2023, DevDecorators. All rights reserved.</p>
{/* <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                        <Link to="#" className="flex justify-center items-center text-teal-800 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Twitter">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                                        </svg>
                                        </Link>
                                    </li>
                                    <li className="ml-4">
                                        <Link to="#" className="flex justify-center items-center text-teal-800 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" aria-label="Facebook">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>
                                        </Link>
                                    </li>
                                </ul>
                                <div className='flex space-x-2'>
                                    <p>Term of services</p>
                                    <p>Privacy Policy</p>
                                </div> */}

                                </div>
    </div>
    <div ></div>
    </div>
    </>
  )
}